<template lang="pug">
    header.topo
        .topo__main(:class="{'shown':menuExpanded}")
            .container
                .main__logo
                    slot(name="logo")
                slot(name="menu")
                .segura__botoes__topo
                    slot(name="whatsapp")
                    button(
                        type="button"
                        aria-label="Abrir Pesquisa"
                        :aria-expanded="pesquisaExpanded ? 'true' : 'false'"
                        aria-haspopup="true"
                        role="button"
                        @click="abrirPesquisa"
                    ).pesquisa__toggler
                        span(aria-hidden="true").fas.fa-search
                        span.sr-only Ícone Pesquisa
        .topo__mobile
            .container
                button(
                    type="button"
                    aria-label="Abrir Pesquisa"
                    :aria-expanded="pesquisaExpanded ? 'true' : 'false'"
                    aria-haspopup="true"
                    role="button"
                    @click="abrirPesquisa"
                ).mbl__toggler
                    span(aria-hidden="true").fas.fa-search
                    span.sr-only Ícone Pesquisa
                .mobile__logo
                    slot(name="logo")
                button(
                    type="button"
                    aria-label="Abrir Menu"
                    :aria-expanded="menuExpanded ? 'true' : 'false'"
                    aria-haspopup="true"
                    role="button"
                    @click="abrirMenu"
                ).mbl__toggler
                    span(aria-hidden="true").fas.fa-bars
                    span.sr-only Ícone Menu
        .topo__pesquisa(:class="{'shown':pesquisaExpanded}")
            slot(name="pesquisa")
        .bg__menu(
            v-if="bgMenu"
            @click="escondeMenu"
            :class="{'hide' : animation}"
            @animationend="sumaBgMenu"
        )
</template>
<script>
export default {
    data() {
        return{
            menuExpanded: false,
            pesquisaExpanded: false,
            bgMenu: false,
            animation: false
        }
    },
    methods: {
        abrirMenu() {
            this.menuExpanded = true;
            this.bgMenu = true;
        },
        abrirPesquisa() {
            this.pesquisaExpanded = true;
            this.bgMenu = true;
        }, 
        escondeMenu() {
            this.menuExpanded = false;
            this.pesquisaExpanded = false;
            this.animation = true;
        },
        sumaBgMenu() {
            if(this.animation) {
                this.bgMenu = false;
                this.animation = false;
            }
        }
    }
}
</script>